import {mount} from 'svelte';

import * as Utils from '@js/modules/utils';
import {videoLazyLoader} from '@js/modules/videoLazyLoader';

import HomeSearch from '@js/components/home/HomeSearch.svelte';
import HomeComputedDistance from '@js/components/home/HomeComputedDistance.svelte';
import RidesRecents from '@js/components/ride/list/RidesRecents.svelte';

const HomeMap = () => import('@js/components/home/HomeMap.svelte');
const HomeAround = () => import('@js/components/home/HomeAround.svelte');
const HomeComputation = () => import('@js/components/home/HomeComputation.svelte');
const RideCreation = () => import('@js/components/ride/RideCreation.svelte');
const ShareUrlButton = () => import('@js/components/ride/share/ShareUrlButton.svelte');


class HomeManager {
    _components = {
        $searchForm: document.getElementById('home-search'),
        $map: document.getElementById('home-map-container'),
        $computedDistance: document.getElementById('home-computed-distance'),
        $computation: document.getElementById('home-computation'),
        $rideCreation: document.getElementById('home-ride-creation'),
        $rideShare: document.getElementById('home-ride-share'),
        $ridesRecents: document.getElementById('home-rides-recents'),
        $homeAround: document.getElementById('home-around')
    };

    _buttons = {
        $insuranceMap: document.getElementById('home-insurance-map'),
        $insuranceTime: document.getElementById('home-insurance-time')
    };

    /* Public methods
    ******************** */
    // constructor() {
    // }

    initialize = () => {
        this._mountComponents();

        this._mountAsyncComponents();

        this._buttonInteractions();

        videoLazyLoader();
    };

    /* Private methods
    ******************** */
    _mountComponents = () => {
        mount(HomeSearch, {
            target: this._components.$searchForm,
            props: {}
        });

        mount(RidesRecents, {
            target: this._components.$ridesRecents,
            props: {
                class: 'main-section mt-24',
                titleClass: 'home-title mb-6'
            }
        });

        if (this._components.$computedDistance) {
            mount(HomeComputedDistance, {
                target: this._components.$computedDistance,
                props: {}
            });
        }
    };

    _mountAsyncComponents = () => {
        Utils.onPageReady(() => {
            HomeMap()
                .then(({default: HomeMapComponent}) => {
                    mount(HomeMapComponent, {
                        target: this._components.$map,
                        props: {}
                    });

                    // Class used for preserving space on initial load
                    this._components.$map.classList.remove('home-map-container');
                });

            HomeAround()
                .then(({default: HomeAroundComponent}) => {
                    mount(HomeAroundComponent, {
                        target: this._components.$homeAround,
                        props: {}
                    });
                });

            setTimeout(() => {
                HomeComputation()
                    .then(({default: HomeComputationComponent}) => {
                        mount(HomeComputationComponent, {
                            target: this._components.$computation,
                            props: {}
                        });
                    });
            }, 800);

            setTimeout(() => {
                RideCreation()
                    .then(({default: RideCreationComponent}) => {
                        mount(RideCreationComponent, {
                            target: this._components.$rideCreation,
                            props: {
                                home: true
                            }
                        });
                    });

                ShareUrlButton()
                    .then(({default: ShareUrlButtonComponent}) => {
                        mount(ShareUrlButtonComponent, {
                            target: this._components.$rideShare,
                            props: {}
                        });
                    });
            }, 2500);
        });
    };

    _buttonInteractions = () => {
        this._buttons.$insuranceMap.addEventListener('click', this._focusOnMap);
        this._buttons.$insuranceTime.addEventListener('click', this._focusOnMap);
    };

    _focusOnMap = (event) => {
        event.preventDefault();

        setTimeout(() => Utils.scrollTo('home-map'), 150);
    };
}

export default new HomeManager();
